var AdaptiveImage = require( "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/ic_shortcut_attendance.ccdfee22.png","uri@2x": __webpack_public_path__ + "static/media/ic_shortcut_attendance.c0ed0190.png","uri@3x": __webpack_public_path__ + "static/media/ic_shortcut_attendance.2e18c1d5.png",
    width: 24,
    height: 24
});